<mat-form-field [appearance]="appearance" fxFlex *ngIf="!selectedProblem">
  <mat-label *ngIf="floatLabel">{{ 'MAINTENANCES.PROBLEM_PLACEHOLDER' | translate }}</mat-label>
  <input
    type="text"
    matInput
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
    [required]="required"
    [disabled]="disabled"
    placeholder="{{ 'MAINTENANCES.PROBLEM_PLACEHOLDER' | translate }}"
  />
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedProblem()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option *ngFor="let problem of problems" [value]="problem.id">
      {{ problem.name }}
    </mat-option>
    <mat-option *ngIf="!problems.length">
      {{ 'MAINTENANCES.PROBLEM_NOT_FOUND' | translate }}
    </mat-option>
  </mat-autocomplete>
  <mat-error class="pb-4">
    <span *ngIf="inputValue.hasError('required')">
      {{ 'MAINTENANCES.ERRORS.PROBLEM_REQUIRED' | translate }}
    </span>
  </mat-error>
</mat-form-field>

<mat-form-field [appearance]="appearance" fxFlex *ngIf="selectedProblem">
  <mat-label *ngIf="floatLabel">{{ 'MAINTENANCES.PROBLEM_PLACEHOLDER' | translate }}</mat-label>
  <div class="flex">
    <input type="text" matInput [value]="selectedProblem.name" disabled required />
    <button
      mat-icon-button
      [disabled]="disabled"
      *ngIf="selectedProblem"
      class="my-cancel-button accent-700-fg"
      (click)="unselectProblem()"
    >
      <mat-icon class="font-size-20">cancel</mat-icon>
    </button>
  </div>
</mat-form-field>
